// Single source of truth for all site content.

export const PROFILE = {
  name: "Mia O'Neill",
  title: "Head of Marketing & Commercial Strategy",
  role: "Marketing & Commercial Strategy",
  email: "mia.lm.oneill@hotmail.co.uk",
  phone: "+44 7366 293 691",
  linkedin: "https://www.linkedin.com/in/miaoneill/",
  linkedinHandle: "linkedin.com/in/miaoneill",
};

// Hero now reduced to a single statement; the body copy sits below.
export const HERO_LINES = ["Hello."];

export const HERO_BODY =
  "Senior marketing & commercial strategy leader. Almost 20 years of building brands, hands-on marketing and digital experiences.";

export const MARQUEE_ITEMS = [
  "Marketing Leadership",
  "Commercial Strategy",
  "Digital Innovation",
  "AR / MR Experiences",
  "Stakeholder Engagement",
  "Global Events",
  "Brand Storytelling",
];

export const STATS = [
  { value: 18, suffix: "", label: "Years in marketing" },
  { value: 200, suffix: "+", label: "Marketing strategies delivered" },
];

export const ABOUT = {
  overline: "Profile",
  statement: "Building brands, strategies and digital experiences.",
  body: [
    "With almost twenty years of experience in marketing and communications, I've built deep expertise in creating digital and creative strategies that engage audiences and support commercial growth. I'm commercially driven and hands-on, managing complex programmes with multiple stakeholder groups.",
    "Over recent years I've led engagement strategies with the UK Government, Scottish Government, Expo 2020 Dubai, UAE Government, the Public Investment Fund & CPPA (KSA), Epic Games and Radisson Hotel Group — translating ambitious agendas into work that moves audiences and the bottom line.",
  ],
  clients: [
    "UK Government",
    "Scottish Government",
    "Expo 2020 Dubai",
    "UAE Government",
    "PIF & CPPA (KSA)",
    "Epic Games",
    "Radisson Hotel Group",
    "GROHE",
    "Scottish Enterprise",
  ],
};

export const SKILLS = [
  { label: "Marketing Strategy", color: "#C2410C" },
  { label: "Brand Development", color: "#1F3A66" },
  { label: "Go-to-Market Strategy", color: "#0F4C3A" },
  { label: "Digital & Demand Generation", color: "#6B4A8E" },
  { label: "Content & Communications", color: "#A0522D" },
  { label: "Customer Experience", color: "#2F5D62" },
  { label: "Proposition Development", color: "#C2410C" },
  { label: "Marketing Operations & AI", color: "#5C4732" },
  { label: "Commercial Growth", color: "#1F3A66" },
  { label: "Leadership & Team Development", color: "#0F4C3A" },
];

export const CAREER = [
  {
    company: "Soluis Group",
    role: "Head of Marketing & Commercial Strategy",
    period: "Jan 2017 — Present",
    duration: "9 yrs +",
    location: "Glasgow",
    body:
      "A global creative and immersive tech organisation. I lead marketing and commercial strategy across the group, with hands-on delivery for all engagements. Leading strategic delivery for clients and partners including Expo 2020 Dubai, UK Govt and Epic Games.",
  },
  {
    company: "Genoa Black",
    role: "Partner — Business, Brand & Marketing",
    period: "Jan 2015 — Jan 2017",
    duration: "2 yrs",
    location: "Edinburgh / UK",
    body:
      "Partner at a B2B strategic marketing consultancy. Developed and managed client marketing strategies to deliver effective, commercially driven projects.",
  },
  {
    company: "Denvir Marketing",
    role: "Marketing Manager · Client Manager",
    period: "Sep 2008 — Apr 2015",
    duration: "6 yrs 8 mos",
    location: "Aberdeen & Stirling",
    body:
      "Developed and delivered integrated campaigns across brand and retail activation, experiential, advertising, PR and digital. Led the creation of a dedicated oil and gas entity in Aberdeen.",
  },
];

// Four Wix projects with media curated per-project from the user's Drive folder.
export const WORK = [
  {
    id: "expo-2020",
    index: "01",
    title: "Expo 2020 Dubai",
    subtitle: "District 2020 — Legacy Engagement",
    role: "Engagement, Comms & Marketing Lead",
    year: "2019—2024",
    tagline: "The future of Expo 2020 Dubai.",
    preview:
      "Led on the coordination engagement for the legacy of Expo 2020 Dubai. Spanning 25+ years for the 47,000,000+ sq. ft sustainable, innovation district.",
    summary:
      "Appointed by Expo 2020 Dubai to deliver the vision for District 2020 — the legacy phase for Dubai's new innovation district. A multi-million-pound contract coordinating 25+ years of engagement for a 47,000,000+ sq. ft sustainable, innovation district.",
    details: [
      "Led on the multi-million-pound legacy contract from 2019 onward.",
      "Delivered the future-district vision through a series of immersive and interactive experiences.",
      "Used digital assets for site design reviews with leadership and architects.",
      "Drove focused marketing and sales campaigns supporting remote onboarding of estate owners, tenants and investors during the 2022 post-event transition.",
    ],
    pullQuote: {
      text: "That was awesome. That was crazy. That was so good.",
      author: "Nadimeh Mehra · VP District 2020, Director — Architecture",
    },
    image: "/media/img/d2020-cityscape-3.jpg",
    previewVideo: "/media/video/d2020-cityscape.mp4",
    previewPoster: "/media/img/d2020-cityscape-3.jpg",
    // Main hero video for the modal — Cityscape only. The iPad video lives in the gallery.
    videos: [
      { src: "/media/video/d2020-cityscape.mp4", title: "District 2020 — Cityscape 2019" },
    ],
    gallery: [
      "/media/img/d2020-cityscape-1.jpg",
      "/media/img/d2020-cityscape-5.jpg",
      "/media/img/d2020-cityscape-10.jpg",
      "/media/img/d2020-app.jpg",
      "/media/img/ms-teams-79.jpg",
    ],
    // Extra videos shown in the gallery area (not in the hero video slot).
    galleryVideos: [
      { src: "/media/video/d2020-ipad.mp4", title: "District 2020 — iPad App" },
    ],
  },
  {
    id: "uk-gov",
    index: "02",
    title: "UK Government",
    subtitle: "Official UK Digital Partner · DIT & Inward Investment",
    role: "Digital Partner Strategy",
    year: "2018—2021",
    tagline: "Partnering with the UK Government on digital engagement for inward investment.",
    preview:
      "Developed the UK Government's digital engagement strategy for inward investment initiatives.",
    summary:
      "Won the appointment of our organisation becoming the Official UK Digital Partner in 2018. I led a UK-wide call for digital collaboration on behalf of the Government with high-profile investment opportunities — launching with stakeholder engagement at the UK Pavilion at MIPIM, the world's leading property event in Cannes, France.",
    details: [
      "UK Pavilion at MIPIM 2019 — VR environments and AR applications brought the pavilion to life.",
      "Showcased UK architecture at its best to global investors and ministers.",
      "Evolved scope into remote engagement tools during COVID-19 restrictions for events and meetings.",
      "Presented programme outcomes to the UK Minister for Investment.",
    ],
    pullQuote: {
      text:
        "HM Government was delighted to work with you in delivering the UK Government pavilion at MIPIM. The VR environments and AR applications really brought the pavilion to life — enabling visitors to immerse themselves in projects created a real buzz.",
      author: "Department for International Trade · Team Lead",
    },
    image: "/media/img/uk-gov-mipim.jpg",
    previewVideo: "/media/video/mipim-2019.mp4",
    previewPoster: "/media/img/uk-gov-mipim.jpg",
    videos: [{ src: "/media/video/mipim-2019.mp4", title: "MIPIM 2019 · Digital Partnership" }],
    gallery: [
      "/media/img/minister.jpg",
      "/media/img/uk-gov-mipim.jpg",
      "/media/img/mipim-team.jpg",
      "/media/img/mipim.jpg",
    ],
    galleryVideos: [],
  },
  {
    id: "grohe",
    index: "03",
    title: "GROHE",
    subtitle: "Pioneering Immersive Tech · Plus Range",
    role: "Innovation & Brand Strategy",
    year: "2021",
    tagline: "Pioneering immersive technology for the global GROHE design team.",
    preview:
      "Pioneering immersive technologies in GROHE to support their design teams to craft interactive customer marketing, stakeholder engagement and sales experiences.",
    summary:
      "Working with the design team at GROHE, I led a pilot to explore and build upon the organisation's digital assets — turning a new line of products into a series of interactive and immersive VR / AR experiences for sales, marketing and stakeholder engagement.",
    details: [
      "Concept-to-launch on a virtual product experience for the GROHE Plus range.",
      "Initial release: an application for use in review meetings — later extended to larger 'shared immersion' installations.",
      "Equipped global sales teams with a portable, augmented showroom — reducing reliance on physical samples and travel.",
    ],
    pullQuote: {
      text:
        "With her leadership, this project has been an absolute success. Mia brings deep expertise, strong leadership, vision and — most importantly — an empathetic point of view for the end-user to the team.",
      author: "VP Design · GROHE",
    },
    image: "/media/img/grohe.jpg",
    previewVideo: "/media/video/grohe-plus.mp4",
    previewPoster: "/media/img/grohe.jpg",
    videos: [{ src: "/media/video/grohe-plus.mp4", title: "GROHE Plus Range" }],
    gallery: ["/media/img/grohe.jpg"],
    galleryVideos: [],
  },
  {
    id: "scottish-enterprise",
    index: "04",
    title: "Scottish Enterprise",
    subtitle: "Marketing Expert Support · Scottish Government",
    role: "Lead Consultant",
    year: "2014—2018",
    tagline: "Marketing Expert Support — intensive strategy for Scottish businesses through growth.",
    preview:
      "Lead consultant delivering over 200 marketing strategies and action plans for Scottish businesses.",
    summary:
      "Lead consultant on the Scottish Government's 'Marketing Expert Support' product as part of Scottish Enterprise business support services — over five years and 200+ marketing consultancy projects across leisure, retail, FMCG, tourism and oil & gas.",
    details: [
      "200+ tailored marketing strategies and action plans for Scottish SMEs and high-growth firms.",
      "Scope spanned market research, business analysis, strategy & planning, and marketing consultancy.",
      "Repeatedly re-commissioned by client organisations to lead delivery of marketing plans beyond the initial engagement.",
    ],
    pullQuote: null,
    image: "/media/img/women-in-biz.jpg",
    previewVideo: null,
    previewPoster: "/media/img/women-in-biz.jpg",
    videos: [],
    gallery: [
      "/media/img/women-in-biz.jpg",
      "/media/img/event-1.jpg",
      "/media/img/event-2.jpg",
    ],
    galleryVideos: [],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "I worked with Mia and her talented team to develop an app-based augmented reality platform to highlight our products in a virtual experience — something our sales team could use from an iPad. Mia delivered a fantastic result. In a few short weeks, I had a highly functional augmented and mixed-reality sales app to showcase new design collections. Mia was the key to the project's success — leading the initiative with a high level of complexity yet delivering on an accelerated timeline. Mia brings a strong level of leadership and inspires those lucky enough to work for and alongside her. Mia holds my strongest endorsement.",
    author: "Michael Seum",
    role: "VP Global Design",
    relationship: "Mia's client",
    initials: "MS",
    color: "#C2410C",
  },
  {
    quote:
      "We worked with Mia and her team for a few years and they were not only very responsive, but thought outside the box and solution oriented. Mia ran point on our project and was very professional.",
    author: "Nadimeh Mehra",
    role: "VP District 2020 · Director, Architecture",
    relationship: "Mia's client",
    initials: "NM",
    color: "#1F3A66",
  },
  {
    quote:
      "Having worked with Mia during three turbulent years, it was always a pleasurable experience. Her positive attitude, professional approach and extensive knowledge in her field made for outstanding outcomes.",
    author: "David Gourlay",
    role: "Design Advisory Services",
    relationship: "Mia's client",
    initials: "DG",
    color: "#5C4732",
  },
  {
    quote:
      "Having known Mia for a few years, when she became available it was an easy decision to place her in charge of bringing Brand Dash to market and managing the company from then on. Mia has tremendous enthusiasm, drive and knowledge and is an asset to this company.",
    author: "Alan W Kinloch",
    role: "Chair — Genoa Black & B4B Strategic Consultancy",
    relationship: "Managed Mia directly",
    initials: "AK",
    color: "#0F4C3A",
  },
  {
    quote:
      "In the 3 years I worked with Mia, I found her to be hugely energetic, highly focused and a knowledgeable marketing professional. A strategic and creative thinker, Mia has a track record of effectively developing, implementing and evaluating successful marketing campaigns. Attention to detail, support and ownership were always evident, and her enthusiasm and drive were contagious — making her highly effective at building strong internal and external relationships. Mia was a pleasure to work with, a great team player, and I would recommend her without hesitation.",
    author: "Lynne Vawser",
    role: "Marketing & Communications · Stakeholder Relations",
    relationship: "Worked with Mia",
    initials: "LV",
    color: "#6B4A8E",
  },
  {
    quote:
      "Mia is an enthusiastic and capable marketing professional who delivers 110% for her clients and team. I was particularly impressed by Mia's breadth of knowledge across leisure, retail, FMCG and tourism — and how quickly she grasped the nuts and bolts of the oil & gas industry. I am pleased to have had the opportunity to work alongside Mia. I highly recommend her and think she would be an asset to any organisation.",
    author: "Lauren Higgins MCIPR",
    role: "Senior Communications & Marketing Professional",
    relationship: "Worked with Mia on the same team",
    initials: "LH",
    color: "#A0522D",
  },
  {
    quote:
      "Mia is a well organised individual with a great depth of knowledge on the projects she manages. I have worked with Mia on several grocery marketing campaigns and have always been impressed by her enthusiasm, motivation and strategy.",
    author: "Claire Partridge CMktr",
    role: "Experienced MD · Chartered Marketer",
    relationship: "Mia's client",
    initials: "CP",
    color: "#2F5D62",
  },
];
